import { writable } from "svelte/store";

export interface BreadcrumbItem {
  label: string;
  url?: string;
}

export const breadcrumbs = {
  active: writable(new Array<BreadcrumbItem>()),
};

export function setCrumbs(crumbs: [string, string][]) {
  breadcrumbs.active.set(
    crumbs.map(([label, url]) => ({ label: label, url: url })),
  );
}
